import { render } from "./WhatIsChatterbox.vue?vue&type=template&id=ac7c41e8&scoped=true&ts=true"
import script from "./WhatIsChatterbox.vue?vue&type=script&lang=ts"
export * from "./WhatIsChatterbox.vue?vue&type=script&lang=ts"

import "./WhatIsChatterbox.vue?vue&type=style&index=0&id=ac7c41e8&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac7c41e8"]])

export default __exports__